import { useFetchNew } from '../../data/fetch/useFetch';
import { parseTournamentsByDate } from '../../data/parseTournamentsByDate';
import { getConfiguration, getTimezoneOffset } from '../../data/utils';
import Loader from '../../common/Loader';
import { useParams } from '../../router/Router';

export default function TournamentsByDateFetcher(props) {
    const conf = getConfiguration();
    const p = useParams();
    const [date, sportId, aggId] = [props.date, props.sportId, props.aggId];

    const [isLoading, isError, data] = useFetchNew(conf.api.getPalinsestoDelGiorno,
        { data: date, idSport: sportId, idAggregata: aggId , timezone: getTimezoneOffset() },
        (data) => {
            return parseTournamentsByDate(data, date, sportId, aggId, p.hour);
        }
    );

    if (isLoading || isError) {
        return (
            <Loader error={isError} />
        );
    }

    return props.renderItem(data);
}
